import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

export class ModNgbTooltip extends NgbTooltip {
    body = (document) ? document.querySelector('body') : undefined;

    addClassToBody(): void { // do my own stuff with tooltip here.
        if (this.body) {
            this.body.classList.add('sg-tooltip');
        }
    }

    open(): void {
        this.addClassToBody();
        super.open();
    }
}
